import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-hour-glass',
  templateUrl: './icon-hour-glass.component.html',
  styles: []
})
export class IconHourGlassComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
